import { z } from 'zod';

export const schema = z.object({
  financialCalculationId: z.number().nonnegative(),
  dealId: z.number().nonnegative(),
  termsheet: z.string().optional().nullable(),
  providerId: z.number().nonnegative(),
  selectedEuriborDateId: z.number().nonnegative(),
  handoverDealerIdEnabled: z.boolean(),
  handoverDealerId: z.number().nonnegative().nullable(),
  commissionDealerId: z.number().nonnegative().nullable().optional(),
});

export type CreditCheckFormValues = z.infer<typeof schema>;
